import React, { useState, useEffect } from "react";
import {
  getFaqs,
  getFaqsById,
  getFaqsBySearch,
} from "../../../services/Faqs&Resourse/faqsServices";
import "../../../assets/scss/components/support.scss";
import Search from "../../../components/CommonCompnents/Support/Search";
import SideBar from "../../../components/CommonCompnents/Support/SideBar";
import Faqs from "../../../components/CommonCompnents/Support/Faqs";

const Support = () => {
  const [faqsData, setFaqsData] = useState("");
  const [isSidebarManu, setIsSideBarManu] = useState({
    isIndividuals: true,
    isPartners: false,
    tabId: "",
  });
  const [faqs, setfaqs] = useState();
  const [searchVal, setSearchVal] = useState("");
  const [searchFaqData, setSearchFaqData] = useState("");

  const getFaqsRes = (res) => {
    if (res.data) {
      setFaqsData(res.data);
      setfaqs(res.data.clntFaq);
    }
  };
  const getFaqsData = () => {
    getFaqs(getFaqsRes);
  };

  const getFaqsDataByIdRes = (res) => {
    if (res.data) {
      setfaqs(res.data);
    }
  };
  const getFaqsDataById = () => {
    getFaqsById(getFaqsDataByIdRes, isSidebarManu.tabId);
    if (window.innerWidth <= 760) {
      document.getElementById("mob-sidebar").style.display = "none";
    }
  };

  const getFaqsDataBySearchRes = (res) => {
    console.log("getFaqsDataBySearchRes", res.data);
    if (res.data) {
      setSearchFaqData(res.data);
    } else {
      setSearchFaqData("");
    }
  };

  const getSearchValue = (val) => {
    setSearchVal(val);
    if (val !== "") {
      let body = {
        searchStr: val,
      };
      getFaqsBySearch(getFaqsDataBySearchRes, body);
    } else {
      setfaqs(faqsData.clntFaq);
    }
  };

  const updateFaqBySearch = (qa) => {
    setSearchVal("");
    setfaqs({ qa: [qa] });
    setSearchFaqData("");
  };

  const showSerachForm = () => {
    let isSearchForm = document.getElementById("mob_search_form");
    isSearchForm.style.display = "block";
    isSearchForm.childNodes[0].childNodes[1].focus();
    isSearchForm.childNodes[0].childNodes[1].placeholder =
      "Search for keywords";
    document.getElementById("support_mob_head").style.display = "none";
  };

  useEffect(() => {
    if (searchVal === "" || searchFaqData === undefined) {
      setSearchFaqData("");
    }
  }, [searchVal]);

  useEffect(() => {
    if (isSidebarManu.tabId !== "") {
      getFaqsDataById();
    } else if (
      isSidebarManu.tabId === "" &&
      isSidebarManu.isPartners &&
      faqsData !== ""
    ) {
      setfaqs(faqsData.vndFaq);
    } else if (
      isSidebarManu.tabId === "" &&
      isSidebarManu.isIndividuals &&
      faqsData !== ""
    ) {
      setfaqs(faqsData.clntFaq);
    }
  }, [isSidebarManu]);

  useEffect(() => {
    getFaqsData();
  }, []);

  window.onclick = (e) => {
    let modal = document.getElementById("mob-sidebar");
    let innerWidth = window.innerWidth;
    if (e.target === modal && innerWidth < 760) {
      document.getElementById("mob-sidebar").style.display = "none";
    }
  };

  return (
    <div className="support">
      <div className="support_content">
        <div className="support_content_left " id="mob-sidebar">
          <div className="support_content_head">
            <h3>Nuvama API FAQs</h3>
          </div>

          <SideBar
            faqsData={faqsData}
            isSidebarManu={isSidebarManu}
            showSidebarMenu={setIsSideBarManu}
          />
        </div>
        <div className="btn_border"></div>

        <div className="support_content_right">
          <div className="support_content_head">
            <div id="support_mob_head">
              <div
                onClick={() =>
                  (document.getElementById("mob-sidebar").style.display =
                    "block")
                }
              >
                Topic Name
                <i className="edel-icon-sort-2"></i>
              </div>
              <div>
                <i
                  onClick={() => showSerachForm()}
                  className="edel-icon-search"
                ></i>
              </div>
            </div>
            <div id="mob_search_form">
              <Search
                searchVal={searchVal}
                setSearchVal={getSearchValue}
                searchFaqData={searchFaqData}
                updateFaqBySearch={updateFaqBySearch}
              />
            </div>
          </div>
          <Faqs faqsData={faqs} />
        </div>
      </div>
    </div>
  );
};

export default Support;
